module.exports = __webpack_public_path__ + "static/GlitchlessSonyax55-4f185fefe6eaad7252da32c9234730cd.png";